export * from './proprietarios-dados-basicos-v2/proprietarios-dados-basicos-v2.module';
export * from './proprietarios-dados-basicos/proprietarios-dados-basicos.module';
export * from './proprietarios-dados-contato/proprietarios-dados-contato.module';
export * from './proprietarios-dados-documentos/proprietarios-dados-documentos.module';
export * from './proprietarios-documentos-selecionar-tipo/proprietarios-documentos-selecionar-tipo.module';
export * from './proprietarios-documentos/proprietarios-documentos.module';
export * from './proprietarios-editar/proprietarios-editar.module';
export * from './proprietarios-ficha-v2/proprietarios-ficha-v2.module';
export * from './proprietarios-ficha/proprietarios-ficha.module';
